/// <amd-module name="Wit/DeliveryPlans/Common/Utils/ArrayUtils" />

/**
 * Binary search to find an element matching a criteria.
 * @param array the array to search, must be sorted ascending
 * @param evaluate evaluation function, should return < 0 if t is too small, > 0 if t is too big, or 0 if t is the correct value.
 */
export function binarySearch<T>(array: T[], evaluate: (t: T) => number): T | undefined {
    let l = 0;
    let r = array.length - 1;
    while (l <= r) {
        const m = Math.floor((l + r) / 2);
        const res = evaluate(array[m]);
        if (res < 0) {
            l = m + 1;
        } else if (res > 0) {
            r = m - 1;
        } else {
            return array[m];
        }
    }
    return undefined;
}
